import { Template } from '../constants/templates';
import { TemplateButton } from './TemplateButton';
import { css } from '@emotion/react/dist/emotion-react.cjs';

interface TemplateListProps {
  templates: Template[];
  expanded: boolean;
  onTemplateMouseEnter?: (
    template: Template,
    coordinates: DOMRect,
    templateIndex: number
  ) => void;
  onTemplateListMouseLeave?: () => void;
  onTemplateSelect: (template: Template) => void;
}

const templatesContainer = (expanded: boolean) => css`
  display: flex;
  flex-direction: column;
  gap: ${expanded ? '8px' : '32px'};
  padding: ${expanded ? '16px' : '32px'} 0px;
`;

export const TemplatesList = ({
  templates,
  expanded,
  onTemplateMouseEnter = () => {
    return;
  },
  onTemplateListMouseLeave,
  onTemplateSelect
}: TemplateListProps) => {
  return (
    <div
      css={templatesContainer(expanded)}
      onMouseLeave={onTemplateListMouseLeave}
      onBlur={onTemplateListMouseLeave}
    >
      {templates.map((template, index) => (
        <TemplateButton
          key={template.id}
          index={index}
          template={template}
          expanded={expanded}
          onMouseEnter={onTemplateMouseEnter}
          onClick={() => onTemplateSelect(template)}
        />
      ))}
    </div>
  );
};
